import { SET_MASTER_SETTINGS_WS, SET_MASTER_SETTINGS } from './chunk-ZDDKJUP6.mjs';
import { REMOVE_MASTER_DATA } from './chunk-P7VATSOY.mjs';
import { SETTINGS_INITIAL_STATE } from './chunk-WKCCF5I3.mjs';
import { produce } from 'immer';

var settingsMasterReducer = produce((state = SETTINGS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MASTER_SETTINGS:
    case SET_MASTER_SETTINGS_WS:
      return action.payload;
    case REMOVE_MASTER_DATA:
      return {};
    default:
      return state;
  }
});
var reducers_default = settingsMasterReducer;

export { reducers_default };
